// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { ItineraryPointSelf, ItineraryPointSelfData, ItineraryPointSelfOptions } from 'data/models/ItineraryPointSelf';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { ScheduleDateSelf, ScheduleDateSelfData, ScheduleDateSelfOptions } from 'data/models/ScheduleDateSelf';
import { ScheduleDateVersion as _ScheduleDateVersion, ScheduleDateVersionData as _ScheduleDateVersionData, ScheduleDateVersionOptions as _ScheduleDateVersionOptions } from 'data/models/ScheduleDateVersion';

// ScheduleDateVersionData is the class that ScheduleDateVersion serializes to/from
export interface ScheduleDateVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    ItineraryPoint : ItineraryPointSelfData | null;
    ItineraryPointId : number;
    JobOrder : JobOrderSelfData | null;
    JobOrderId : number;
    MilestoneTypeId : number | null;
    NextVersion : _ScheduleDateVersionData[] | null;
    PortCall : PortCallSelfData | null;
    PortCallId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _ScheduleDateVersionData | null;
    Self : ScheduleDateSelfData | null;
	
    Deleted : boolean;
    Type : string | null;
}

// ScheduleDateVersionOptions is the class which may be passed to the ScheduleDateVersion constructor to define optional initial data values
export interface ScheduleDateVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    ItineraryPoint? : ItineraryPointSelfOptions | null;
    ItineraryPointId? : number;
    JobOrder? : JobOrderSelfOptions | null;
    JobOrderId? : number;
    MilestoneTypeId? : number | null;
    NextVersion? : _ScheduleDateVersionOptions[] | null;
    PortCall? : PortCallSelfOptions | null;
    PortCallId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _ScheduleDateVersionOptions | null;
    Self? : ScheduleDateSelfOptions | null;
	
    Deleted? : boolean;
    Type? : string | null;
}

export class ScheduleDateVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public ItineraryPoint : DataSignal<ItineraryPointSelf | null>;
    public ItineraryPointId : DataSignal<number>;
    public JobOrder : DataSignal<JobOrderSelf | null>;
    public JobOrderId : DataSignal<number>;
    public MilestoneTypeId : DataSignal<number | null>;
    public NextVersion : SDataArray<_ScheduleDateVersion>;
    public PortCall : DataSignal<PortCallSelf | null>;
    public PortCallId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_ScheduleDateVersion | null>;
    public Self : DataSignal<ScheduleDateSelf | null>;
	
    public Deleted : DataSignal<boolean>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : ScheduleDateVersionOptions);
    constructor(data: ScheduleDateVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.ItineraryPoint = S.value<ItineraryPointSelf | null>(null);
        this.ItineraryPointId = jsonableObservable(S.value<number>(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : 0));
        this.JobOrder = S.value<JobOrderSelf | null>(null);
        this.JobOrderId = jsonableObservable(S.value<number>(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.MilestoneTypeId = jsonableObservable(S.value<number | null>(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : null));
        this.NextVersion = SArray<_ScheduleDateVersion>([]);
        this.PortCall = S.value<PortCallSelf | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_ScheduleDateVersion | null>(null);
        this.Self = S.value<ScheduleDateSelf | null>(null);
	    
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : ScheduleDateVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : ScheduleDateVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : ScheduleDateVersion, data : ScheduleDateVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ItineraryPointId !== undefined) obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined) obj.JobOrderId(data.JobOrderId);
            if (data.MilestoneTypeId !== undefined) obj.MilestoneTypeId(data.MilestoneTypeId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
	        
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleDateVersion.ts